"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FULL_HEIGHT = exports.ALL_ID = exports.shouldBeInEditableMode = exports.calculateScrollableContentHeight = exports.shouldHaveInfiniteScrolling = void 0;
var tableHeader = 40;
var rowHeight = 58;
var rowMargin = 1;
var shouldHaveInfiniteScrolling = function (hasInfiniteScrollableContentLoading, initialNumberOfRowsToShow, rowsLength, totalNumberOfRows) {
    var hasInitialNumberOfRowsToShow = initialNumberOfRowsToShow > 0;
    var hasRowsOverflowingScrollableContent = rowsLength >= initialNumberOfRowsToShow;
    var hasTotalNumberOfRows = !!totalNumberOfRows;
    return (hasInfiniteScrollableContentLoading &&
        hasInitialNumberOfRowsToShow &&
        hasRowsOverflowingScrollableContent &&
        hasTotalNumberOfRows);
};
exports.shouldHaveInfiniteScrolling = shouldHaveInfiniteScrolling;
var calculateScrollableContentHeight = function (initialNumberOfRowsToShow) {
    return tableHeader + initialNumberOfRowsToShow * (rowHeight + rowMargin);
};
exports.calculateScrollableContentHeight = calculateScrollableContentHeight;
var shouldBeInEditableMode = function (isEditableField, field) {
    return (field.editable && isEditableField) || field.alwaysEditable;
};
exports.shouldBeInEditableMode = shouldBeInEditableMode;
exports.ALL_ID = 'all';
exports.FULL_HEIGHT = '100%';
